(function (Drupal, drupalSettings) {
  Drupal.behaviors.forms = {
    attach: function (context, settings) {
      const forms = context.querySelectorAll("form");
      forms.forEach((form) => {
        if (!form.dataset.formsProcessed) {
          form.dataset.formsProcessed = "true";

          const inputs = form.querySelectorAll(
            ".js-form-type-textfield input, .js-form-type-email input"
          );
          inputs.forEach((input) => {
            input.addEventListener("focusin", function () {
              input.parentElement.classList.add("focusin");
            });

            input.addEventListener("focusout", function () {
              if (input.value === "") {
                input.parentElement.classList.remove("focusin");
              }
            });
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
